import { createFileRoute } from "@tanstack/react-router";
import { FeedbackDetailPage } from "../features/feedback/pages/detail-page";

/** One report as the operator works on it (EP-53, US-53.6). */
export const Route = createFileRoute("/feedback/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <FeedbackDetailPage id={id} />;
}
